import React from 'react'
import { PromoTextLinkImg } from '../../types'

export const PromoComponent: React.FC<PromoTextLinkImg> = props => {
    return (
        <>
            <div className={'promo-text art-list__promo padding--no'}>
                <PromoImage {...props} />
                <div className="promo-text__content" style={{ backgroundColor: '#'+props.backgroundColour }}>
                    <h3 className="promo-text__title">{props.title}</h3>
                    <p className="promo-text__text">{props.text}</p>
                    <PromoLink {...props} />
                </div>
            </div>
        </>
    )
}

export const PromoLink: React.FC<PromoTextLinkImg> = props => {
    const incompleteLinkObject = !props.link.url ||!props.link.name 
    return incompleteLinkObject ? ( <></> ) : (
        <a
            className="promo-text__button btn--black"
            href={props.link.url}
            title={props.link.name}
            target={props.link.target ?? ''}
        >
            {props.link.name}
        </a>
    )
}

export const PromoImage: React.FC<PromoTextLinkImg> = props => {
    const incompleteImageObject = !props.image.mobile || !props.image.tablet || !props.image.desktop
    return incompleteImageObject ? ( <></> ) : (
        <picture className="promo-text__img">
            <source srcSet={props.image.desktop} media="(min-width: 1200px)" />
            <source srcSet={props.image.tablet} media="(min-width: 768px)" />
            <img src={props.image.mobile}  alt={props.image?.altText ?? ''} />
        </picture>
    )
}
